// @ts-expect-error
var debugTools = require("../src/common/debug");

window["debug"] = debugTools.debug;
window["info"] = debugTools.info;
window["warn"] = debugTools.warn;
window["error"] = debugTools.error;
